import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnNetworkData extends SnModel {
  @Expose()
  public defaultGateway: string;

  @Expose()
  public dns: string[];

  @Expose()
  public ipAddress: string;

  @Expose()
  public method: string;

  @Expose()
  public subnetMask: string;
}
